var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"talkme-content"},[_c('content-get-start'),_c('content-comments'),_c('content-letter'),_c('content-ai-tour'),_c('contentSpeaking'),_c('contentBetterAI'),_c('contentBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }